import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import { Link, Route, withRouter } from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import Popover, { PopoverAnimationVertical } from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';

import MapIcon from 'material-ui/svg-icons/maps/map';
import ChartIcon from 'material-ui/svg-icons/editor/insert-chart';
import TableIcon from 'material-ui/svg-icons/action/view-list';

class ViewDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleClick = event => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  menuButton(theme, pathname) {
    if (pathname.match(/\/map/)) {
      return (
        <div>
          <MapIcon
            style={{ margin: '6px 10px -6px 0' }}
            color={theme.colors.gold500}
          />
          <span>Map View</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            style={{ margin: '5px 10px -4px 7px' }}
          >
            <path d="M5 8l4 4 4-4z" />
          </svg>
        </div>
      );
    }
    if (pathname.match(/\/chart/)) {
      return (
        <div>
          <ChartIcon
            style={{ margin: '6px 10px -6px 0' }}
            color={theme.colors.gold500}
          />
          <span>Chart View</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            style={{ margin: '5px 10px -4px 7px' }}
          >
            <path d="M5 8l4 4 4-4z" />
          </svg>
        </div>
      );
    }
    if (pathname.match(/\/table/)) {
      return (
        <div>
          <TableIcon
            style={{ margin: '6px 10px -6px 0' }}
            color={theme.colors.gold500}
          />
          <span>Table View</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            style={{ margin: '5px 10px -4px 7px' }}
          >
            <path d="M5 8l4 4 4-4z" />
          </svg>
        </div>
      );
    }
  }

  render() {
    const { theme, location, match: { params } } = this.props;

    return (
      <Route
        render={({ location: { pathname } }) => (
          <div>
            <RaisedButton
              onClick={this.handleClick}
              buttonStyle={{
                fontSize: '14px',
                width: '168px',
                height: '42px',
                lineHeight: '42px',
              }}
              overlayStyle={{
                width: '168px',
                height: '42px',
                lineHeight: '42px',
              }}
            >
              {this.menuButton(theme, pathname)}
            </RaisedButton>

            <Popover
              open={this.state.open}
              anchorEl={this.state.anchorEl}
              anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
              targetOrigin={{ horizontal: 'left', vertical: 'top' }}
              animation={PopoverAnimationVertical}
              onRequestClose={this.handleRequestClose}
            >
              <Menu className="viewSelector">
                <MenuItem
                  style={{ fontSize: '14px' }}
                  onClick={this.handleRequestClose}
                  containerElement={
                    <Link
                      to={{
                        pathname: `/map${
                          params.cityId ? '/' + params.cityId : ''
                        }`,
                        search: location.search,
                      }}
                    />
                  }
                >
                  <MapIcon
                    style={{ margin: '0 10px -6px 0' }}
                    color={
                      pathname.match(/\/map/)
                        ? theme.colors.gold500
                        : theme.colors.grey500
                    }
                  />
                  <span>Map View</span>
                </MenuItem>

                {!params.cityId ? (
                  <MenuItem
                    style={{ fontSize: '14px' }}
                    onClick={this.handleRequestClose}
                    containerElement={
                      <Link
                        to={{
                          pathname: '/chart',
                          search: location.search,
                        }}
                      />
                    }
                  >
                    <ChartIcon
                      style={{ margin: '0 10px -6px 0' }}
                      color={
                        pathname.match(/\/chart/)
                          ? theme.colors.gold500
                          : theme.colors.grey500
                      }
                    />
                    <span>Chart View</span>
                  </MenuItem>
                ) : null}
                <MenuItem
                  style={{ fontSize: '14px' }}
                  onClick={this.handleRequestClose}
                  containerElement={
                    <Link
                      to={{
                        pathname: `/table${
                          params.cityId ? '/' + params.cityId : ''
                        }`,
                        search: location.search,
                      }}
                    />
                  }
                >
                  <TableIcon
                    style={{ margin: '0 10px -6px 0' }}
                    color={
                      pathname.match(/\/table/)
                        ? theme.colors.gold500
                        : theme.colors.grey500
                    }
                  />
                  <span>Table View</span>
                </MenuItem>
              </Menu>
            </Popover>
          </div>
        )}
      />
    );
  }
}

export default withTheme(withRouter(ViewDropdown));



// WEBPACK FOOTER //
// ./src/components/ViewDropdown.jsx